module.exports = __webpack_public_path__ + "img/lxwm.8397bad1.png";